import { Controller } from "@hotwired/stimulus"

// The CSV column-mapping step (data_imports/_column_mapping): each field comes from one column, so choosing a field
// for a column takes it off any other (whose pill-select repaints on the change event).
export default class extends Controller {
  static targets = ['select']

  change(event) {
    const field = event.target.value
    if (!field) return

    this.selectTargets
      .filter(select => select !== event.target && select.value === field)
      .forEach(select => {
        select.value = ''
        select.dispatchEvent(new Event('change', { bubbles: true }))
      })
  }
}
